import ConfiguracaoGatewayPagamentoModel from "@/models/configuracaoGatewayPagamentoModel";
import nfetch from "@/utils/events/nfetch";

import { iServiceCached } from "./base/iServiceCached";

class ConfiguracaoGatewayPagamentoService extends iServiceCached<ConfiguracaoGatewayPagamentoModel> {
    constructor() {
        super("ConfiguracaoFranquiaGatewayPagamento");
    }

    public async comboCached(franquiaId: number) {
        return await this.combo(franquiaId);
    }

    public async comboMethod() {
        try {
            const response = await nfetch(`/${this.controllerName}/ListGateway?`, {
                credentials: "same-origin",
            })
                .withLoading()
                .resolveWithJSON<any[]>(false);

            return response;
        } catch {}

        return [];
    }
}

export default new ConfiguracaoGatewayPagamentoService();
